import { render, staticRenderFns } from "./RepCursos.vue?vue&type=template&id=486af73a&"
import script from "./RepCursos.vue?vue&type=script&lang=js&"
export * from "./RepCursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports